module.exports = __webpack_public_path__ + "static/media/plan-free.d27610fb.svg";